export default "__VITE_PUBLIC_ASSET__def2b710__"